import { Injectable, Type } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export abstract class ImageChatCodeGenerationService {
  abstract generateCode(image: string): Observable<File | null>;
  abstract applyCodeAndImage(image: File | null, code: string): Observable<void>;
}

export function provideImageChatCodeGenerationService(service: Type<ImageChatCodeGenerationService>) {
  return [
    service,
    {
      provide: ImageChatCodeGenerationService,
      useExisting: service,
    },
  ];
}
